import * as React from "react";
const SvgFiRrBalloon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-balloon_svg__a)">
      <path
        fill="#062147"
        d="M22 9.378C22 4.215 17.514.015 12 .015S2 4.215 2 9.378c0 5.287 3.362 11.119 8.111 12.379a4.6 4.6 0 0 0-.583 1.246.786.786 0 0 0 .759.998h3.424c.52 0 .905-.498.759-.998a4.6 4.6 0 0 0-.583-1.246c4.749-1.26 8.111-7.092 8.111-12.38zM12 20.015c-4.506 0-8-5.718-8-10.637 0-4.061 3.589-7.363 8-7.363s8 3.303 8 7.363c0 4.919-3.494 10.637-8 10.637m4.813-8.878a9.8 9.8 0 0 1-1.463 3.489.962.962 0 0 1-1.442.19c-.363-.325-.411-.862-.141-1.267a7.6 7.6 0 0 0 1.134-2.778.95.95 0 0 1 .933-.771h.034c.599 0 1.064.549.945 1.137"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-balloon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBalloon;
